<template>
    <section class="market-analysis container" id="market" data-anchor="market">

        <div class="block-header">

            <h2>Market analysis for</h2>

            <SelectPair v-model="chosenPair"
                        :available-pairs="availablePairs"
            >
            </SelectPair>

        </div>

        <table class="custom-table">
            <thead>
            <tr>
                <th class="text"></th>
                <th class="text">Exchange</th>
                <th class="text market-price">Market Price</th>
                <th class="text td-change-24">Change 24h</th>
                <th class="text td-change-24">Volume 24h</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(exchange, index) in exchanges"
                :key="exchange.id"
                :class="['exchange-row', 'wow', 'fadeInUp', {'active': isCurrentRow(index)}]"
                @mouseenter="setCurrentRow(index)"
                data-wow-delay="0.1"
            >

                <td><img :src="getIcon(exchange.icon)" :alt="`${ exchange.icon } exchange icon`"></td>
                <td class="exchange-name text">{{ exchange.name }}</td>
                <td class="text market-price">${{ exchange.price.separatedDigits }}.{{ exchange.price.fraction }}</td>
                <td :class="['text', 'td-change-24', 'shift', {'positive': exchange.change.number > 0, 'negative': exchange.change.number < 0 }]">
                    {{ exchange.change.number >= 0 ? (exchange.change.number > 0 ? '+' : '') : (Math.abs(exchange.change.number) > 1 ? '' : '-') }}{{ exchange.change.separatedDigits ? exchange.change.separatedDigits : 0 }}.{{ exchange.change.fraction }}%
                </td>
                <td class="text td-change-24">
                    ${{ exchange.value.separatedDigits }}.{{ exchange.value.fraction }}
                </td>

            </tr>
            </tbody>

            <div class="candles-container" :style="`top: ${ getChosenOffset - 130 }px;`">
                <Candles :data="chosenExchange.candles"
                >
                </Candles>
            </div>

        </table>

        <div class="chosen-row" :style="`top: ${ getChosenOffset }px;`"></div>

    </section>
</template>

<script>
    import SelectPair from "./SelectPair"
    import Candles from "./Candles"
    import { SERVER_URL } from "../servers"

    export default {
        name: "MarketAnalysis",
        components: {
            SelectPair,
            Candles
        },
        data() {
            return {
                currentPair: 'BTC/USDT',
                availablePairs: ["BTC/USDT", "ETH/USDT", "LTC/USDT", "XRP/USDT", "EOS/USDT", "DASH/USDT"],

                exchanges: [],
                currentRow: 0,
                getChosenOffset: 203,

                interval: null,
                updatingDelay: 24 * 1000 // 24 seconds
            }
        },
        computed: {
            chosenExchange() {
                return this.exchanges.length ? this.exchanges[this.currentRow] : {}
            },
            currentTool: {
                get() {
                    return this.currentPair
                },
                set(value) {
                    this.currentPair = value
                }
            },
            chosenPair: {
                get() {
                    return this.currentPair
                },
                set(value) {
                    this.currentPair = value

                    this.uploadExchangesList()
                }
            }
        },
        methods: {
            roundNumber(number, deep) {
                return Math.floor(number * (10 ** deep)) / (10 ** deep)
            },
            getNumberParts(number, separator = ',', deep = 2) {
                var result = {
                    number: number ? this.roundNumber(+number, deep) : 0,
                    int: Math.trunc(number),
                    fraction: Math.abs(Math.floor((Math.floor((number * (10 ** deep))) - ( Math.trunc(number) * (10 ** deep) )) * (10 ** deep)) / (10 ** deep)),
                    separatedDigits: ''
                }

                if ((result.fraction + '').length === 0) {
                    result.fraction = '00'
                } else if ((result.fraction + '').length === 1) {
                    result.fraction = '0' + result.fraction
                }

                var string = result.int + ''

                for (var i = string.length - 1; i >= 0; i -= 3) {
                    if (i > 2) {
                        result.separatedDigits = separator + string[i - 2] + string[i - 1] + string[i] + result.separatedDigits
                    } else {
                        result.separatedDigits = string.substr(0, i + 1) + result.separatedDigits
                    }
                }

                return result
            },
            isCurrentRow(index) {
                return this.currentRow === index
            },
            setChosenOffset(index) {

                var element = document.getElementsByClassName('exchange-row')[index]

                var currentOffsetTop = element.offsetTop
                var rowHeight        = element.offsetHeight

                this.getChosenOffset = currentOffsetTop + (rowHeight * 2) - 3

            },
            setCurrentRow(index) {
                if (!this.isCurrentRow(index)) {

                    this.currentRow = index

                    this.setChosenOffset(index)

                }
            },
            getIcon(icon) {
                return require(`@/assets/images/icons/exchanges/${ icon }.svg`)
            },
            startUpdatingInterval() {

                this.uploadExchangesList()

                this.interval = setInterval(() => {

                    this.uploadExchangesList()

                }, this.updatingDelay)

            },
            uploadExchangesList() {
                this.$axios.get(`${SERVER_URL}/public/exchangeInfo/${ this.currentPair }`)
                    .then((response) => {

                        this.updateExchangesList(response.data.exchanges)

                    }).catch((error) => {
                    window.console.log(error)
                })

            },
            adapterExchangeName(name) {
                switch (name) {
                    case 'gateio':
                        return 'Gate.io'
                    case 'upbit':
                        return 'UpBit'
                    case 'huobipro':
                        return 'Huobi Global'
                    case 'coinbasepro':
                        return 'Coinbase Pro'
                    case 'okex':
                        return 'OKEx'
                    case 'hitbtc':
                        return 'HitBTC'
                    default:
                        return name
                }
            },
            updateExchangesList(exchanges) {

                var result = []

                for (var exchange in exchanges) {

                    if (exchanges[exchange].ticker.last_price !== 0) {

                        result.push({
                            icon: exchange,
                            name: this.adapterExchangeName(exchange),
                            price: this.getNumberParts(exchanges[exchange].ticker.last_price),
                            change: this.getNumberParts(exchanges[exchange].ticker.change_price_24h_perc),
                            value: this.getNumberParts(exchanges[exchange].ticker.quoteVolume_24h),
                            candles: exchanges[exchange].candles,
                            data: exchanges[exchange]
                        })

                    }

                }

                if (result.length - 1 < this.currentRow) {

                    this.setCurrentRow(result.length - 1)

                }

                this.exchanges = result

            }
        },
        created() {

            this.startUpdatingInterval()

        }
    }
</script>